import { AiAssistantSocket } from '@mint-sdk/api-ai-assistant';
import { Manager } from 'socket.io-client';

const URL = globalThis.location.port
  ? `ws://${globalThis.location.hostname}:${globalThis.location.port}`
  : 'wss://' + globalThis.location.hostname;

export type ChatSocketClient = AiAssistantSocket.ChatSocketClient;

export const createChatSocketClient = (chatId: string): ChatSocketClient => {
  const manager = new Manager(
    URL.concat(AiAssistantSocket.AI_ASSISTANT_CHAT_SOCKET_PATH),
    {
      transports: ['websocket'],
      path: AiAssistantSocket.AI_ASSISTANT_CHAT_SOCKET_PATH,
      autoConnect: false,
      query: { chat_session_id: chatId },
    },
  );

  return manager.socket('/');
};
